<template>
    <div>
        <v-form ref="form" @submit.prevent="submit" v-model="valid">
            <!--<FormItem>
            <template #question>Child Information</template>
            <template #response>
                <div
                    class="flex flex-col gap-4"
                    :class="{ 'mb-4': idx + 1 !== form.children.length }"
                    v-for="(child, idx) of form.children.length"
                    :key="child[idx]"
                >
                    <div
                        class="flex justify-between gap-4"
                        :class="{ 'flex-col ': $vuetify.breakpoint.xs }"
                    >
                        <SoliText
                            v-model="form.child_first_name"
                            icon="person"
                            label="Child's First Name"
                            :rules="[
                                (v) =>
                                    !!v ||
                                    `Your child's first name is required`,
                            ]"
                            hideDetails="auto"
                            :error="errors.child_first_name"
                        />
                        <SoliText
                            v-model="form.child_last_name"
                            icon="people"
                            label="Child's Last Name"
                            :rules="[
                                (v) =>
                                    !!v || `Your child's last name is required`,
                            ]"
                            hideDetails="auto"
                            :error="errors.child_last_name"
                        />
                    </div>
                    <SoliBirthday
                        v-model="form.child_birthday"
                        label="Child's Birthday"
                        required
                        hideDetails="auto"
                    ></SoliBirthday>
                    <v-divider v-if="idx + 1 !== form.children.length" />
                </div>
            </template>
        </FormItem>-->

            <FormItem>
                <template #question>Who's going?</template>
                <template #end>
                    <div class="text-body-1 font-weight-regular text-align-end">
                        {{
                            `${
                                eventRegister.details.capacity -
                                eventRegister.details.attending -
                                eventRegister.details.pending -
                                form.attending.length +
                                (eventRegister.attendingInCart?.quantity ?? 0)
                            } seats available`
                        }}
                    </div>
                    <div class="text-sm font-weight-regular text-align-end">
                        {{ `Reserving ${form.attending.length} seat(s)` }}
                    </div>
                </template>
                <template #action>
                    <v-row no-gutters class="gap-2">
                        <div>
                            <v-btn
                                x-small
                                outlined
                                class="soli-round"
                                color="accent"
                                @click="relationshipForm = true"
                                >Add Relationship</v-btn
                            >
                        </div>
                    </v-row>
                </template>
                <template #response>
                    <v-autocomplete
                        v-model="form.attending"
                        :items="relationships"
                        no-data-text="No relationships found"
                        multiple
                        chips
                        deletable-chips
                        item-text="name"
                        item-value="id"
                        label="Your relationships"
                        outlined
                        class="soli-blue-text"
                        prepend-inner-icon="people"
                        :error-messages="errors.attending"
                        hide-details="auto"
                        :rules="[
                            (val) =>
                                val.length <=
                                    eventRegister.details.capacity -
                                        eventRegister.details.pending -
                                        eventRegister.details.attending ||
                                'This event is over capacity, please contact us to join the waitlist',
                            (val) =>
                                !!(val || '').length > 0 ||
                                'This field is required',
                        ]"
                    >
                        <template v-slot:item="data">
                            <v-list-item-avatar>
                                <img :src="data.item.profile_photo_url" />
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title
                                    v-html="data.item.name"
                                ></v-list-item-title>
                                <v-list-item-subtitle
                                    v-html="data.item.email"
                                ></v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                </template>
            </FormItem>

            <FormSubmit
                :loading="loading"
                :errors="errors"
                valid
                dark
                type="submit"
                gradient="gradient-orange"
                icon="send"
                text="Checkout"
            />
        </v-form>

        <GuestCreateRelationship
            v-if="relationshipForm"
            :guest="guest"
            :user="user"
            :relationships="relationships"
            @success="
                [
                    closeModal(() => (relationshipForm = false)),
                    form.attending.push(relationships[0].id),
                ]
            "
            @reset="closeModal(() => (relationshipForm = false))"
        />
    </div>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment";
import FormRules from "../../Mixins/FormRules";
import FormItem from "../Form/FormItem.vue";
import FormTitle from "../Form/FormTitle.vue";
import FormSubmit from "../Form/FormSubmit.vue";
import BookingEmail from "../Booking/BookingEmail.vue";
import BookingSimpleSelect from "../Booking/BookingSimpleSelect.vue";
import SoliResponsiveDialog from "../Base/SoliResponsiveDialog.vue";
import GuestCreateRelationship from "../Guest/GuestCreateRelationship.vue";

export default {
    mixins: [globalMoment, FormRules],
    components: {
        FormTitle,
        FormItem,
        FormSubmit,
        BookingEmail,
        BookingSimpleSelect,
        SoliResponsiveDialog,
        GuestCreateRelationship,
    },
    props: {
        errors: {},
        user: {
            type: Object,
            default: () => {},
        },
        guest: {
            type: Object,
            default: () => {},
        },
        relationships: {
            type: Array,
            default: () => [],
        },
        eventRegister: {
            type: Object,
            default: () => {},
        },
        guestData: {
            type: Object,
            default: () => {},
        },
        discount: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                update_guest: false,
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                attending:
                    this.eventRegister.attendingInCart?.recipients?.map(
                        (e) => e.recipient_id
                    ) ?? this.relationships.map((e) => e.id),
            }),
            loading: false,
            valid: false,
            relationshipForm: false,
        };
    },
    methods: {
        submit() {
            if (!this.$refs.form.validate()) {
                this.$nextTick(() => {
                    const el = document.querySelector(
                        ".v-messages.error--text"
                    );
                    el.scrollIntoView({ block: "center" });
                });

                return;
            }

            this.loading = true;

            this.form.post(
                route("eventRegistration.store", {
                    eventRegister: this.eventRegister.hash_id,
                }),
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.loading = false;
                        this.$emit("success");
                    },
                    onError: (errors) => {
                        this.loading = false;
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                        if (errors.contactSupport) return;
                        if (errors.soliError) return;
                    },
                }
            );
        },
        reset() {
            this.$refs.form.reset();
        },
    },
    watch: {
        "form.attending"(val) {
            this.$emit("input", val);
        },
        guestData: {
            deep: true,
            handler(val) {
                if (!val) return;
                this.form.first_name = val.first_name;
                this.form.last_name = val.last_name;
                this.form.email = val.email;
                this.form.phone = val.phone;
                this.form.update_guest = true;
            },
        },
    },
    mounted() {
        this.$emit("input", this.form.attending);
    },
};
</script>
